/**
 * 멘션 자동완성 후보에서 본인을 제외. 자기 자신을 멘션하는 의미가 없으므로 UI 후보 단에서 차단.
 * @param {Array} members  채널 멤버 — { id, employee?:{ id, ... }, ... }
 * @param {number|null|undefined} myEmployeeId  /employees/me 의 id (Employee.id)
 */
export function withoutSelf(members, myEmployeeId) {
    if (myEmployeeId == null) return members || [];
    return (members || []).filter(m => (m.employee?.id ?? m.id) !== myEmployeeId);
}

/**
 * 채널 본문(text 또는 html)에서 @이름 토큰을 추출 → 채널 멤버와 매칭 → employeeCode 배열 반환.
 *
 * 백엔드 ChannelFeedService.notifyMentions 가 받을 mentionedEmployeeCodes 필드를 채우는 용도.
 * 댓글(plain text)·게시글(html) 양쪽에서 같은 함수를 사용해 동작을 맞춘다.
 *
 * 매칭 정책:
 *  - 본문에서 정규식 /@([\w가-힣\-]+)/g 로 토큰 추출.
 *    하이픈(-) 포함 — 사내 employee.name 이 "test1-조지현", "김선우-관리자" 같이 - 를 포함.
 *    이게 빠지면 자동완성으로 잘 선택한 멘션이 추출 단계에서 누락되어 알람이 안 감.
 *  - 토큰 문자열이 멤버의 name 과 정확히 일치하면 채택 (부분 일치 X — 오탐 방지)
 *  - 동명이인은 첫 매치 (현 직원 DB 구조상 사실상 발생하지 않지만 명시)
 *  - employeeCode 없는 멤버는 skip
 *  - 결과는 중복 제거된 배열
 *
 * @param {string} text  본문 — text or html
 * @param {Array}  members  채널 멤버 — { id, name, employeeCode, ... } 또는 { employee: { ... } }
 * @returns {string[]} 매칭된 employeeCode 배열 (빈 입력이면 [])
 */
export function extractMentionedEmployeeCodes(text, members) {
    if (!text || !Array.isArray(members) || members.length === 0) return [];

    // html 태그 제거 후 일반 텍스트로
    const plain = String(text).replace(/<[^>]+>/g, " ");

    const tokens = new Set();
    const re = /@([\w가-힣\-]+)/g;
    let m;
    while ((m = re.exec(plain)) !== null) tokens.add(m[1]);
    if (tokens.size === 0) return [];

    const codes = new Set();
    for (const mem of members) {
        const emp  = mem.employee || mem;
        const name = emp?.name;
        const code = emp?.employeeCode;
        if (!name || !code) continue;
        if (tokens.has(name)) codes.add(code);
    }
    return [...codes];
}
